'use strict';

import React from 'react';
import Hero from './Hero'
import Services from './Services'
import About from './About'
import Clients from './Clients'

class Home extends React.Component {
  render() {
    return (
      <div className="content-component">
        <Hero />
        <Services />
        <About />
        <Clients />
      </div>
    );
  }
}

Home.displayName = 'Home';

// Uncomment properties you need
// Home.propTypes = {};
// Home.defaultProps = {};

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js